import React from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Form as BootstrapForm } from "react-bootstrap";
import toast from "react-hot-toast";



const Notes = ({ selectedId, initialId }) => {

    const { data, refetch, isLoading } = useQuery({
        queryKey: ["notesData", selectedId, initialId], // Ensure re-fetch on changes
        queryFn: () => getRequest(`/lead/notes/info?leadId=${selectedId ? selectedId : initialId}`),
        enabled: selectedId !== null || initialId !== null
    });

    const notesData = data?.data


    console.log("notesDatanotesDatanotesData", notesData)

    const { mutate, isLoading: apiState } = useMutation({
        mutationFn: (data) => {
            return postRequest("/lead/notes", data);
        },
        onSuccess: (data) => {
            if (data?.statusCode == 200) {
                toast.success(`${data?.message}`, {
                    iconTheme: {
                        primary: '#337FE0',
                        secondary: '#FFFAEE',
                    },
                })
            }
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });

    return (
        <Formik
            initialValues={{ note: notesData?.note || "" }}
            enableReinitialize

            onSubmit={(values) => {
                console.log(values);
                if (values) {
                    const payload = {
                        leadId: selectedId ? selectedId : initialId,
                        note: values?.note
                    }
                    mutate(payload);
                }

            }}
        >
            {({ handleSubmit, values }) => (
                <Form onSubmit={handleSubmit}>
                    <BootstrapForm.Group className="mb-3 nots-text-area" controlId="exampleForm.ControlTextarea1">
                        <Field
                            as={BootstrapForm.Control}
                            name="note"
                            component="textarea"
                            rows={3}
                        />
                        <ErrorMessage name="note" component="div" className="text-danger" style={{ color: "red" }} />
                    </BootstrapForm.Group>
                    {values?.note && <button type="submit" className="theme-comm-btn">Save</button>}


                </Form>

            )}
        </Formik>



    )
}

export default Notes


